import "./MyAchivementsCard.css";

import { useState, useEffect } from "react";

import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { CiCircleInfo } from "react-icons/ci";
import { LuChartNoAxesCombined } from "react-icons/lu";
import { GiOpenBook } from "react-icons/gi";
import { IoMdPlanet } from "react-icons/io";
import { IoRocketSharp } from "react-icons/io5";
import SiriusRoadmap from "../../medias/images/sirius-roadmap.png";
import { GrAchievement } from "react-icons/gr";
import { FaCalendarCheck, FaClock, FaCheckCircle } from "react-icons/fa";

import { useUserAchievements } from "../../hooks/useUserAchievements.js";
import { DataTable } from "primereact/datatable";
import { getAchievements } from "../../services/wisdomServices/userService.js";
import { Column } from "docx";
import { getSessionItem } from "../../utils/helper/session.js";
import { format } from "date-fns";

const AchievementsSkeleton = () => {
  return (
    <div
      className="my-progress-skeleton"
      aria-hidden="true"
    >
      {[1, 2, 3].map((item) => (
        <div
          className="my-progress-skeleton-row"
          key={item}
        >
          <div className="my-progress-skeleton-info">
            <span className="my-progress-skeleton-icon" />
            <span className="my-progress-skeleton-label" />
          </div>

          <span className="my-progress-skeleton-value" />
        </div>
      ))}
    </div>
  );
};

const MyAchivementsCard = () => {
  const [openProgressLine, setOpenProgressLine] = useState(false);
  const [openAchievementsDialog, setOpenAchievementsDialog] = useState(false);
  const {achievements,levelConfig,loadingAchievements,achievementsError,} = useUserAchievements();
  const [myAchievements, setMyAchievements] = useState([]);
  const [loadingMyAchievements, setLoadingMyAchievements] = useState(false);
  const user = getSessionItem("User")
  useEffect(() => {
    loadMyAchievements();
  }, [])

  const loadMyAchievements = async () => {
    try {
      setLoadingMyAchievements(true)
      const response = await getAchievements(user?.id);
      setMyAchievements(response)
    } catch (error) {
      console.error("Error: ", error)
    } finally {
      setLoadingMyAchievements(false)
    }
  }
  const titleBodyTemplate = () => {
    return (
      <h4
        style={{ cursor: "pointer", fontSize:"1.1rem", fontWeight:"600", fontFamily:"sans-serif" }}
        onClick={(e) => {
          e.stopPropagation();
          setOpenProgressLine(true);
        }} 
      >
        <LuChartNoAxesCombined /> Your mission in numbers <CiCircleInfo />
      </h4>
    );
  };

  const dialogHeaderTemplate = () => {
    return (
      <h4>
        <GrAchievement /> My Achievements
      </h4> 
    )
  };

  const completedAtBodyTemplate = (rowData) => {
    return (
      <span><FaCalendarCheck /> {format(new Date(rowData?.completedAt), "yyyy-MM-dd")}</span>
    )
  }

  const durationBodyTemplate = (rowData) => {
    return(
      <span><FaClock /> {rowData?.duration}h</span>
    )
  }

  const courseBodyTemplate = (rowData) => {
    return(
      <span><FaCheckCircle /> {rowData?.courseName}</span>
    )
  }

  return (
    <>
      <Card
        title={titleBodyTemplate}
        className="my-progress-card"
        style={{ maxHeight: "208px"}}
      >
        {loadingAchievements ? (
          <AchievementsSkeleton />
        ) : achievementsError ? (
          <div className="my-progress-card-status my-progress-card-error">
            Unable to load achievements.
          </div>
        ) : achievements ? (
          <div style={{ cursor: "pointer" }} onClick={() => setOpenAchievementsDialog(true)}>
            <div className="my-progress-summary-card-content">
              <div>
                <span>
                  <GiOpenBook />
                  Missions completed
                </span>
              </div>

              <div>
                <span>{achievements.completedCourses ?? 0}</span>
              </div>
            </div>

            <div className="my-progress-summary-card-content">
              <div>
                <span>
                  <IoMdPlanet />
                  Hours of learning
                </span>
              </div>

              <div>
                <span>
                  {achievements.totalHoursCompleted ?? 0}h
                </span>
              </div>
            </div>

            <div className="my-progress-summary-card-content">
              <div>
                <span>
                  <IoRocketSharp />
                  Your current level
                </span>
              </div>

              <div>
                <span>
                  {levelConfig?.label ?? achievements.level}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-progress-card-status">
            No achievement information found.
          </div>
        )}
      </Card>

      <Dialog
        visible={openProgressLine}
        onHide={() => setOpenProgressLine(false)}
        closeOnEscape
        dismissableMask
        className="progress-roadmap-dialog"
        style={{
          width: "90vw",
          maxWidth: "1515px",
          aspectRatio: "1515 / 564",
          backgroundImage: `url(${SiriusRoadmap})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <Dialog
        visible={openAchievementsDialog}
        onHide={() => setOpenAchievementsDialog(false)}
        header={dialogHeaderTemplate}
        closeOnEscape
        dismissableMask
        className="achievements-dialog"
        
      >
        <DataTable
          value={myAchievements}
          footer={`${myAchievements.length} completed courses`}
          rows={10}
        >
          <Column header="Course" body={courseBodyTemplate}/>
          <Column header="Duration" body={durationBodyTemplate}/>
          <Column header="Completed at" body={completedAtBodyTemplate}/>
        </DataTable>
      </Dialog>
    </>
  );
};

export default MyAchivementsCard;